import React, { FC } from 'react';
import classnames from 'classnames';
import ListItem from './list-item';
import styles from './index.style.less';

interface IProps {
  children?: React.ReactNode;
  title: React.ReactNode;
  subTitle?: string;
  className?: string;
}

const Panel: FC<IProps> & { ListItem: typeof ListItem } = ({
  children,
  title,
  subTitle,
  className,
}) => {
  return (
    <div
      className={classnames([
        styles.container,
        { [className as string]: !!className },
      ])}
    >
      <div className={classnames([styles.head, 'panel-conponent-head'])}>
        {title}
        {subTitle && (
          <span
            className={classnames([
              styles.subTitle,
              'panel-conponent-sub-title',
            ])}
          >
            {subTitle}
          </span>
        )}
      </div>
      {typeof children !== 'undefined' && (
        <div className={styles.body}>{children}</div>
      )}
    </div>
  );
};

Panel.ListItem = ListItem;

export default Panel;
